import React from 'react';
import './MapPage.css';

import { serviceAreas } from '../../../constants';
import { Heading, PageTitle } from '../../../components';

import { FaLocationDot } from 'react-icons/fa6';



const AvailabilityMap = () => {

  // Function to divide array into chunks
  const chunkArray = (array, chunks) => {
    const chunkSize = Math.ceil(array.length / chunks);
    return Array.from({ length: chunks }, (_, i) =>
      array.slice(i * chunkSize, i * chunkSize + chunkSize)
    );
  };

  // Divide service areas into 4 groups
  const serviceAreaGroups = chunkArray(serviceAreas, 4);

  // Google Maps embed URL
  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4359806.469117153!2d143.92684986722568!3d-32.119423508797006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0dcb74f75e4b0d%3A0x1780af1122c49f2d!2sNew%20South%20Wales%2C%20Australia!5e0!3m2!1sen!2s!4v1730772719873!5m2!1sen!2s";

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Availability map'} page={'availability map'} />

      <section className="availability-map">

        {/* Google Map Section */}
        <div className="google-map">

          {/* Section Heading */}
          <Heading title={'Our Coverage Map'} subTitle={'Explore Our Service Areas'} />

          <iframe 
            src={mapUrl} 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            title="Service Coverage Map"
          ></iframe>

        </div>

        {/* Network Coverage Areas Section */}
        <div className="network-areas">

          {/* Section Heading */}
          <Heading title={'Network Areas'} subTitle={'Areas We Serve'} />

          {/* Service Area Container */}
          <div className="box-container">
            {serviceAreaGroups.map((group, groupIndex) => (
              <div className="area-item" key={`area-group-${groupIndex}`}>
                {group.map((area, areaIndex) => (
                  <div className='area-group' key={`area-${groupIndex}-${areaIndex}`}>
                    <div className='icon'><FaLocationDot /></div>
                    <span>{area}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>

        </div>

      </section>

    </>

  );
};

export default AvailabilityMap;